<div class="content-wrapper">

  <div class="title-container">

    <button class="icon-button" (click)="onBack()">
      <tun-arrow-back36px-icon-v5 class="icon icon-large-scaled-svg-button"></tun-arrow-back36px-icon-v5>
    </button>

    <div class="title">{{'playlist.overlay.addTrack.one.title' | translate }}</div>

  </div>

  <tun-add-song-to-playlist
    class="contentContainer"
    [tracks]="[track]"
    (addToPlaylist)="onAddToPlaylist($event)"
    (onAddToQueue)="onAddToQueue()"
    (createAndAddToPlaylist)="onCreateAndAddToPlaylist($event)"
  >

  </tun-add-song-to-playlist>






</div>
